<div class="contact-card">
    <div class="container">
        <div class="row align-items-center flex-wrap h-100">
            <div class="col-md-6 text-left">
                <h2 class="font-600 h2-text">
                    Want to plan your infrastructure with us?
                </h2>
                <br>
                <button type="button" class="btn brand-button" routerLink="/product/journey">Experience it for yourself
                    <img src="assets/img/arrow-white.svg" alt="" class="arrow-in-button">

                </button>
            </div>
            <div class="col-md-6">
                <img class="float-right mt-3" src="assets/img/infrastructure.svg" alt="Build out your digital infrastructure" width="400rem">
            </div>
        </div>
    </div>
</div>